module.exports = __webpack_public_path__ + "img/official-3.6870cb94.png";